import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Project6Card = () => {
    return (
        <Container>
            <Row>
                <Col lg={10} className='mx-auto'>
                    <p className='lead'>
                        As a college student, I was constantly frustrated by limited, expensive parking near campus,
                        while many residents with unused street parking passes let them sit idle. WePark let those
                        residents list their unused spot and set an hourly price, while drivers searched a live map
                        for the nearest open space.
                    </p>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>What I Built</h3>
                    <ul>
                        <li>A map-based interface for browsing nearby available parking spaces in real time.</li>
                        <li>A listing flow for space owners to post a spot and set their own hourly rate.</li>
                        <li>Integrated payment processing to handle transactions between renters and space owners.</li>
                    </ul>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>Outcome</h3>
                    <p>
                        The app delivered a working peer-to-peer marketplace for a real, everyday problem, turning
                        parking passes that would otherwise sit unused into a flexible source of income for their
                        owners.
                    </p>

                    <p className='text-muted mb-0'><i>Completed May 2019</i></p>
                </Col>
            </Row>
        </Container>
    )
}

export default Project6Card;
